import { BaseNameSideItem } from '@Enum/index';

// on navigating to My Requests need to choose Leave Request by default
// const LEAVE_REQUESTS = `${ESSFeatureRoutePath.MANAGE_REQUESTS}/leave-request`;

const MenuItemRouteName: { [key: string]: string } = {
  [BaseNameSideItem.DASHBOARD]: 'dashboard',
  [BaseNameSideItem.MY_REQUESTS]: 'manage-requests',
  [BaseNameSideItem.APPROVALS]: 'approvals',
  [BaseNameSideItem.PROCUREMENT]: 'procurement',
};

export default MenuItemRouteName;
